<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid" v-bind:id="'container_' + _uid" ref="container">
    <div class="pull-left" style="margin-top:12px;">
      <slot name="buttons" scope="testScope"></slot>
    </div>
    <ul class="list-inline mb-0 my-3 pull-right">
      <li class="list-inline-item">
        <a href="#" @click="expand" style="color:inherit;" class="text-default p-2 btn-light">
          <i class="icon-comment-discussion"></i> {{$t('discuss')}} ({{nrofitems}})
          <i v-if="expanded == true" class="icon-arrow-down32"></i>
          <i v-if="expanded == false" class="icon-arrow-up32"></i>
        </a>
      </li>
    </ul>
    <div v-if="expanded == true" v-bind:id="'messages-' + _uid" class="pb-2" v-bind:class="css" style="float:left;width:100%;">
      <div class="btn-group justify-content-center" style="float:right;position" v-if="displayfiles == true">
        <a href="#" class="" data-toggle="dropdown"><i class="icon-menu"></i></a>
        <div class="skinnedmenu dropdown-menu">
          <div v-on:click="toggleUploadFile();" class="dropdown-item">{{$t('upload')}}</div>
        </div>
      </div>
      <uploadfiles uid="{'threadid:' + node.threadid}" v-if="displayfiles == true" v-bind:visibility="displayState.filesAreVisible"></uploadfiles>

      <div class="discuss-thread-container p-2 mb-2" style="max-height:calc(50vh - 100px); min-height:calc(25vh - 100px);overflow-y:auto" v-bind:id="'messagecontainer' + threadid">
        <discuss-recursive-message v-bind:forumname="forumname" style="padding:10px;" v-for="node in messageTree" v-bind:mode="viewmode" :islast="node.isLast" v-bind:unformattedlabel="node.unformattedlabel" :isadmin="node.isadmin" :nodes="node.nodes" :username="node.UserName" v-bind:issinglemessage="node.issinglemessage" :label="node.label" :messageid="node.messageid" :threadid="node.threadid" :dateandtime="node.dateandtime" :userabbreviation="node.userabbreviation" v-on:updatedthread="parentUpdatedthreadHandler"></discuss-recursive-message>
        <div id="bottom"></div>
      </div>

      <div class="row px-2">
        <div class="col-10 col-md-11 p-0 pl-0">
          <textarea class="skin form-control col-12 base-messageinput messageinput" v-bind:class="'messageinput' + _uid" v-on:keyup.enter="reply" v-bind:placeholder="$t('enter_message')" v-model:value="message" v-bind:id="'messageinput' + _uid" style="float:left;width:100%;">

          </textarea>
          <!--<input type="text"  class="form-control messageinput" v-on:keyup.enter="reply" v-bind:placeholder="$t('enter_message')"  v-model:value="message" v-bind:id="'messageinput' + threadid"  style="float:left;">-->
        </div>
        <div class="col-2 col-md-1 px-0 pl-1">
          <button type="button" class="btn skin primary-button px-1" style="float:right;width:100%;" @click="reply"><i class="icon-plus3"></i></button>
        </div>

      </div>


    </div>
    <ticker ref="ticker"></ticker>
  </div>
</template>

<script>

  import ticker from '../common/common-ticker.vue'
  import discussRecursiveMessage from './discuss-recursive-message.vue'
  import uploadfiles from '../upload/upload-files.vue'
  import vuescroll from 'vuescroll';
  var doScroll = true;
  var _threadId = -1;
  var message = "";
  let messageTree = [];
  var tmpdisplayState = {
    filesAreVisible: false
  };


  export default {

    name: 'discuss-singlethread-miniview',
    components: {
      discussRecursiveMessage,
      uploadfiles,
      ticker,
      vuescroll
    },
    props: {
      /*
      uid: {
        required: false,
        type: String,
        default: null
      },*/
      externaluid: {
        required: false,
        type: String,
        default: null
      },
      css: {
        required: false,
        type: String,
        default: null
      },
      threadtitle: {
        required: false,
        type: String,
        default: null
      },
      mode: {
        required: false,
        type: String,
        default: "tree"
      },
      enablefiles: {
        required: false,
        type: Boolean,
        default: false
      },
      forumname: {
        required: false,
        type: String,
        default: null
      },
    },
    data() {
      return {
        expanded: false,
        nrofitems:0,
        message,
        _threadId,
        displayfiles: this.enablefiles,
        displayState: tmpdisplayState,
        messageTree,
        viewmode: this.mode,
        doScroll,
        ops: {
          vuescroll: {
            mode: 'slide',
            detectResize: true,
          },
          scrollPanel: {
            scrollingX: false
          },
          rail: {
            background: '#F6F7F7',
            opacity: 0.5,
            size: '6px',
            specifyBorderRadius: false,
            gutterOfEnds: null,
            gutterOfSide: '2px',
            keepShow: false
          },
          bar: {
            onlyShowBarOnScroll: false,
            keepShow: true,
            background: '#666767',
          }
        }
      };
    },


    methods: {
      setExternaluid(val) {
        this.externaluid = val;
      },
      setThreadtitle(val) {
        this.threadtitle = val;
      },
      expand() {
        var thisContext = this;
        this.expanded = !this.expanded;
        this.$forceUpdate();
        setTimeout(function () {
          $('#messageinput' + thisContext._uid).emojioneArea(
            {
              tones: true,
            });
        }, 1000)

        $('#messageinput' + thisContext._uid).emojioneArea(
          {
            tones: true,
          });
      },
      handleResize() {
        //this.tryScrollToBottom();
      },
      toggleUploadFile() {
        displayState.filesAreVisible = true;
      },
      async reply() {

        var m = $('.messageinput' + this._uid).val();
        var thisContext = this;

        var request = { AddReplyThreadId: this._threadId, message: m, AddReplyMessageId: -1, uid: this.externaluid, threadtitle: this.threadtitle, forumname: this.forumname };
        try {
          var response = await this.$http.post(
            '/api/Threads/v1/Reply',
            request
          ).then((response) => {
            if (this._threadId == -1 && response.data.ThreadId) {
              this._threadId = response.data.ThreadId;
            }

            this.doScroll = true;

            this.getThreadMessages(thisContext._threadId);

            this.message = "";
            //$('.messageinput' + this._uid).emojioneArea
            $('#messageinput' + thisContext._uid).data("emojioneArea").setText("")
            //$('.messageinput' + thisContext._uid).emojioneArea.setText("")

          });
        } catch (err) {
          alert(err);
        }
      },
      reload() {
        this.doScroll = true;
        if (this._threadId > -1) {
          this.getThreadMessages(this._threadId);
        }
        else if (this.externaluid != null) {
          this.getContextThread(this.externaluid);
        }
        //setTimeout(this.reload, 10000);
      },
      async getThreadMessages(threadid) {
        try {
          this.$http.get(`/api/Threads/v1/${threadid}?` +'page=0').then(async response => {
            if (response.data != null && response.data.Threads) {
              Vue.set(this, "messageTree", this.makeMessageTree(response.data.Threads, -1))
            }
            else {
              this.messageTree = [];
            }

            this.$forceUpdate();
            initOEmbed();

          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      getContextThread(uid) {
        try {
          this.externaluid = uid;
          this.$http.get('/api/Threads/v1/Uid/' + uid + '?page=0').then(response => {
            //[HttpGet("Uid/{uid}")]
            if (response.data != null) {
              // Got the threadid from context
              if (response.data != null && typeof (response.data.ThreadId) != "undefined") {
                this._threadId = response.data.ThreadId;
                Vue.set(this, "messageTree", this.makeMessageTree(response.data.Threads, -1))
              }
              else {
                this._threadId = -1;
                Vue.set(this, "messageTree", [])
              }
            }
            else {
              // There is not thread created yet
              this.messageTree = [];
            }

            this.$forceUpdate();
            initOEmbed();

          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      /*
      tryScrollToBottom() {
        var thisContext = this;
        if (thisContext.doScroll == true) {
          setTimeout(function () {
            thisContext.$refs.scroller.scrollTo(
              {
                y: "100%"
              },
              500
            );
            thisContext.doScroll = false;
          }, 1)
        }
        else {
        }
      },*/

      makeMessageTree(threads2, id) {
        this.nrofitems = threads2.length;

        var children = [];

        for (var i = 0; i < threads2.length; i++) {
          if (id == threads2[i].ParentId) {
            var childNode = {};
            childNode.isLast = false;
            childNode.label = this.emojiString(threads2[i].Content, childNode);
            childNode.unformattedlabel = threads2[i].Content;
            childNode.UserName = threads2[i].UserName;
            childNode.messageid = threads2[i].MessageId;
            childNode.isadmin = threads2[i].IsAdmin;
            childNode.threadid = this._threadId;
            if (threads2[i].DisplayTime != null)
              childNode.dateandtime = threads2[i].DisplayTime;
            if (threads2[i].DisplayDate != null)
              childNode.dateandtime += " " + threads2[i].DisplayDate;
            childNode.userabbreviation = threads2[i].UserAbbreviation
            childNode.nodes = this.makeMessageTree(threads2, threads2[i].MessageId);
            children.push(childNode);
          }

        }

        if (children.length > 0 && children.length > 1) {
          children[children.length - 1].isLast = true;
        }

        return children;
      },

      parentUpdatedthreadHandler(id) {
        this.getThreadMessages(this._threadId);
        //$('.emojionearealocked').each(function (i, d) {
        //  $(d).emoji();
        //});
      },
      setThreadId(id) {
        this._threadId = id;
      },
      emojiString(str, node) {

        if (str == null)
          return "";

        var keys = '';

        var animations = '\\abe|access|angel|airplane|alarm_clock|alien|anger|angry|astonished|bandit|beer|bell|bertlett|bhangra|bike|bing|birthday|blackwidow|blush|bollylove|bomb|boom|bow|bowled|brb|bug|broken_heart|bulb|cake|call|camera|canyoutalk|car|cat|captain|chai|champagne|chappal|cheese|christmas_tree|clap|clapper|confetti_ball|clock|coffee|crown|cry|crying_cat_face|computer|computerrage|confidential|cool|cwl|coutinho10|dance|devil|dhakkan|discodancer|disgust|diya|dizzy_face|dog|doh|donkey|donttalktome|drink|drunk|dull|eg|emo|envy|evilgrin|excel|eyes|facepalm|finger|fear|fingerscrossed|fistbump|fireworks|fish|fishing_pole_and_fish|fist|flushed|flower|frog|frowning|footballfail|fubar|ghost|gift|giggle|golmaal|goodluck|gottorun|grimacing|grin|grinning|hamburger|handshake|handsinair|hanukkah|happy|headbang|headphones|heart|heart_eyes|heartbeat|heartpulse|hearts|heidi|henderson14|hi|highfive|holdon|holidayspirit|hollest|helicopter|hug|horse|hushed|hungover|idea|inlove|internetexplorer|island|joy|kaanpakadna|kangaroo|key|kiss|kissing_face|klopp|kya|laugh|laughing|learn|letsmeet|lips|lipssealed|listening|man|mlt|mmm|microsoft|mail|makeup|monkey|mooning|movie|muscle|music|muscleman|movember|nahi|nazar|neil|nerdy|nickfury|ninja|no|nod|naturescall|notes|ok|oliver|onedrive|onenote|ontheloo|outlook|oye|party|penguin|pig|poop|phone|pizza|plane|poke|polarbear|poolparty|powerpoint|praying|priidu|prohibed|promise|publisher|puke|pullshot|pumpkin|punch|rain|rainbow|raindeer|rabbit|rocket|roller_coaster|rock|runner|rofl|sad|sadness|santa|santamooning|sarcastic|shake|sharepoint|sheep|shielddeflect|shivering|shopping|skipping|skull|skype|skypebiz|slap|sleepy|smile|smirk|smoke|snowangel|speechless|star|stop|sturridge15|surprised|snail|suryannamaskar|swear|sweat|sunny|sunrise|talk|talktothehand|tandoorichicken|taur|think|time|tired_face|tmi|toivo|tongueout|tubelight|tumbleweed|turkey|umbrella|vampire|wait|waiting|wfh|whatsgoingon|whistle|woman|wink|win10|whew|wasntme|wonder|word|worry|xmastree|xbox|wtf|victory|violin|volcano|yawn|yes|yoga|zany|zombie|zipper';
        //var animations = '\\airplane|alarm_clock|alien|anger|angry|astonished|birthday|blush|bomb|boom|bug|bulb|camera|christmas_tree|clap|clapper|confetti_ball|crown|cry|crying_cat_face|disappointed|dizzy_face|eyes|fireworks|fish|fishing_pole_and_fish|fist|flushed|frog|frowning|ghost|grimacing|grin|grinning|hamburger|heart|heart_eyes|heartbeat|heartpulse|hearts|helicopter|horse|hushed|kiss|kissing_face|laughing|lips|notes|penguin|pig|poop|rabbit|rocket|roller_coaster|runner|sunny|sunrise|tired_face|volcano|';
        var animationRegex = new RegExp(':(' + animations + '):', 'g');
        var regex = new RegExp(':(' + keys + '):', 'g');
        // Row breaks should be visible in html
        str = str.replace(/(?:\r\n|\r|\n)/g, '<br>');
        var tmpStr = str.replace(/:/g, '');
        node.issinglemessage = false;
        if (animations.includes(tmpStr)) {
          // Animation, make it bigger
          node.issinglemessage = true;
          return str.replace(animationRegex, this.emojiReplaceAnimationBig);
        }
        else if (typeof (keys.includes) != 'undefined' && keys.includes(tmpStr)) {
          // Just a single icon, make it bigger
          node.issinglemessage = true;
          return str.replace(regex, this.emojiReplaceBig);
        }
        else {
          str = str.replace(animationRegex, this.emojiReplaceAnimation); 
          return str.replace(regex, this.emojiReplace);
        }
          
      },
      emojiReplaceAnimationBig() {
        var key = arguments[1];
        //var url = 'https://github.com/SCRAPTURE/jquery-emoji/raw/master/images/emojis';
        var url = '/images/emoji/animations';
        var extension = '.gif';
        var src = url + '/' + key + extension;
        return '<img class="emoji" width="60" height="60" align="absmiddle" src="' + src + '" alt="' + key + '" title="' + key + '" />';
      },
      emojiReplaceBig() {
        var key = arguments[1];
        //var url = '/images/emoji/static';
        var url = 'https://github.com/SCRAPTURE/jquery-emoji/raw/master/images/emojis';
        var extension = '.png';
        var src = url + '/' + key + extension;
        return '<img class="emoji" width="60" height="60" align="absmiddle" src="' + src + '" alt="' + key + '" title="' + key + '" />';
      },
      emojiReplaceAnimation() {
        var key = arguments[1];
        //var url = 'https://github.com/SCRAPTURE/jquery-emoji/raw/master/images/emojis';
        var url = '/images/emoji/animations';
        var extension = '.gif';
        var src = url + '/' + key + extension;
        return '<img class="emoji" width="20" height="20" align="absmiddle" src="' + src + '" alt="' + key + '" title="' + key + '" />';
      },
      emojiReplace() {
        var key = arguments[1];
        var url = 'https://github.com/SCRAPTURE/jquery-emoji/raw/master/images/emojis';
        //var url = '/images/emoji/static';
        var extension = '.png';
        var src = url + '/' + key + extension;
        return '<img class="emoji" width="20" height="20" align="absmiddle" src="' + src + '" alt="' + key + '" title="' + key + '" />';
      }
    },
    mounted() {
      this.$refs.ticker.start(this.$refs.container.getAttribute('id'));
      this.reload();
      this.$refs.ticker.end(this.$refs.container.getAttribute('id'));

      if (this.mode != "flat") {
        this.$root.$emit('nux', this.$t('nux_discussion_detail'));
      }

      this.$emit("chatmounted", this);

    },
    created: function () {

    },

    updated() {
      
    },


  }

</script>
<style>
  .emoji {
    vertical-align: top;
  }
  .messageinput_remove {
    width: calc(100% - 110px);
    float: left !important;
  }

  .messageinput {
    min-height:38px;
  }

  .base-messageinput {
    float: left;
  }

  .emojionearea-picker {
    right: initial !important;
    left: 0px;
  }

  .emojionearea-button{
      padding-top:3px;
  }

  .emojionearea-editor {
    min-height: 38px !important;
  }
</style>

<style scoped>
  
  

  .emoji {
    vertical-align: top;
  }
  .messageinput{
    width: calc(100% - 110px);
    float: left !important;
    min-height:38px;
  }
  .discuss-thread-container {
    padding-bottom: 25px;
  }
  .discuss-thread-container{
      overflow:visible;
  }

</style>



// WEBPACK FOOTER //
// src/components/discuss/discuss-singlethread-miniview.vue